import { useEffect } from "react";
import { useBrowserTitleStore } from "client_legacy/ndaw/browserTitle";
import { Guid } from "client_legacy/ndaw/guid";

const layoutTitleElement: HTMLElement | null = document.querySelector<HTMLElement>("#title-bar .title-bar__title");

export function usePageTitle(title: string): void {
	const setBrowserTitle: ((title: string) => Guid) = useBrowserTitleStore(x => x.setTitle);
	const clearBrowserTitle: ((token: Guid) => void) = useBrowserTitleStore(x => x.clearTitle);

	useEffect(
		() => {
			const oldLayoutTitle: string | undefined = layoutTitleElement?.innerText;
			const oldLayoutTooltipTitle: string | undefined = layoutTitleElement?.title;

			const browserTitleToken: Guid = setBrowserTitle(title);
			if (layoutTitleElement) {
				layoutTitleElement.innerText = title;
				layoutTitleElement.title = title;
			}

			return () => {
				clearBrowserTitle(browserTitleToken);
				if (layoutTitleElement) {
					layoutTitleElement.innerText = oldLayoutTitle!;
					layoutTitleElement.title = oldLayoutTooltipTitle!;
				}
			};
		},
		[
			clearBrowserTitle,
			setBrowserTitle,
			title
		]
	);
}